import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Renders the variant's net weight (e.g. "2 oz / 56 g") near the price
 * and re-syncs on variant change. Reads native `variant.weight` server-side
 * (already grams, set by mfg-integration shopify-sync).
 *
 * Strategy mirrors variant-metafields-component: variant-picker dispatches
 * `variant:update` with the fresh section HTML; we locate the matching block
 * in that HTML by `data-block-id` and swap our content in.
 */
class VariantWeightComponent extends Component {
  /** @type {HTMLElement | null} */
  #target = null;

  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    if (!target) return;
    this.#target = target;
    target.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.#target) {
      this.#target.removeEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
      this.#target = null;
    }
  }

  /**
   * @param {CustomEvent<{ data?: { html?: Document } }>} event
   */
  handleVariantUpdate = (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;

    const blockId = this.dataset.blockId;
    if (!blockId) return;

    const next = html.querySelector(
      `variant-weight-component[data-block-id="${CSS.escape(blockId)}"]`
    );
    if (!next) return;

    const nextContent = next.querySelector('.variant-weight__value');
    const currentContent = this.querySelector('.variant-weight__value');
    if (nextContent && currentContent) {
      currentContent.innerHTML = nextContent.innerHTML;
    }

    this.classList.toggle(
      'variant-weight--empty',
      next.classList.contains('variant-weight--empty')
    );
  };
}

if (!customElements.get('variant-weight-component')) {
  customElements.define('variant-weight-component', VariantWeightComponent);
}
